module.exports = __webpack_public_path__ + "img/incision-logo_thumbnail.67da44a4.jpg";